import { render, staticRenderFns } from "./SiteMapSkeltonLoader.vue?vue&type=template&id=fdc354d6&"
import script from "./SiteMapSkeltonLoader.vue?vue&type=script&lang=ts&"
export * from "./SiteMapSkeltonLoader.vue?vue&type=script&lang=ts&"
import style0 from "./SiteMapSkeltonLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCol,VItemGroup,VRow,VSkeletonLoader,VTab,VTabItem,VTabs,VTabsSlider})
